"use strict";
/**
 * Utils module.
 * @module tree
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTreeKey = exports.tree2list = exports.list2tree = void 0;
/**
 * list转tree
 * @param root
 * @returns Array<TreeNode>
 */
var list2tree = function (list) {
    var e_1, _a;
    var listData = JSON.parse(JSON.stringify(list));
    function getChildren(id, tar) {
        var e_2, _a, e_3, _b;
        var children = [];
        try {
            for (var tar_1 = __values(tar), tar_1_1 = tar_1.next(); !tar_1_1.done; tar_1_1 = tar_1.next()) {
                var node = tar_1_1.value;
                if (node.pid === id) {
                    children.push(node);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (tar_1_1 && !tar_1_1.done && (_a = tar_1.return)) _a.call(tar_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                var node = children_1_1.value;
                var children_2 = getChildren(node.id, list);
                if (children_2.length) {
                    node.children = children_2;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return children;
    }
    var tree = [];
    try {
        for (var listData_1 = __values(listData), listData_1_1 = listData_1.next(); !listData_1_1.done; listData_1_1 = listData_1.next()) {
            var node = listData_1_1.value;
            // 如果没有pid就可以认为是根节点
            if (!node.pid) {
                var p = __assign({}, node);
                p.children = getChildren(p.id, listData);
                tree.push(p);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (listData_1_1 && !listData_1_1.done && (_a = listData_1.return)) _a.call(listData_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return tree;
};
exports.list2tree = list2tree;
/**
 * tree2list
 * @param tree
 * @returns TreeList
 */
var tree2list = function (tree) {
    var treeData = JSON.parse(JSON.stringify(tree));
    var list = [];
    var queue = __spreadArray([], __read(treeData), false);
    while (queue.length) {
        var node = queue.shift();
        if (node === null || node === void 0 ? void 0 : node.children) {
            var children = node.children;
            if (children === null || children === void 0 ? void 0 : children.length) {
                queue.push.apply(queue, __spreadArray([], __read(children), false));
            }
            // 移除children字段
            delete node.children;
        }
        if (node) {
            list.push(node);
        }
    }
    return list;
};
exports.tree2list = tree2list;
/**
 * 从树形数据中，删除指定key
 * @function
 * @param data
 * @param keyFlag
 * @returns T[]
 */
var removeTreeKey = function (data, keyFlag) {
    var cloneData = JSON.parse(JSON.stringify(data));
    cloneData.map(function (my) {
        var _a;
        if (my[keyFlag]) {
            delete my[keyFlag];
        }
        if ((_a = my === null || my === void 0 ? void 0 : my.children) === null || _a === void 0 ? void 0 : _a.length) {
            var tar = (0, exports.removeTreeKey)(my.children, keyFlag);
            my.children = tar;
        }
        return my;
    });
    return cloneData;
};
exports.removeTreeKey = removeTreeKey;
//# sourceMappingURL=index.js.map